<div class="search-container">
  <form class="form-search-bar" [formGroup]="searchForm" (ngSubmit)="handleSubmit()" autocomplete="off">

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'kf-reporting.year' |translate}}</mat-label>
      <input matInput type="text" [formControl]="yearControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.countries.name' |translate}}</mat-label>
      <input matInput type="text" [formControl]="nameControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>Round of questions {{'kf-reporting.launched' |translate}}</mat-label>
      <mat-select [formControl]="isLaunchControl">
        <mat-option value=""> - </mat-option>
        <mat-option [value]="true"> Yes </mat-option>
        <mat-option [value]="false"> No </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label> {{'kf-reporting.launched' |translate}} range</mat-label>
      <mat-date-range-input [rangePicker]="picker"  [disabled]="isLaunchControl.value === 'no'" >
        <input matStartDate [formControl]="startLaunchedControl">
        <input matEndDate [formControl]="endLaunchedControl">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker ></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.countries.status' |translate}}</mat-label>
      <mat-select [formControl]="statusControl">
        <mat-option value="">-</mat-option>
        <mat-option value="ACTIVE">Active</mat-option>
        <mat-option value="INACTIVE">Inactive</mat-option>
      </mat-select>
    </mat-form-field>

    <button type="reset" mat-raised-button (click)="clean()">Clean</button>
    <button type="submit" mat-raised-button color="primary">Apply</button>
  </form>
</div>
